import React from "react";
import "./BannerLeyora.scss";
import Comingsoon from "../../Media/Leyora_Desktop.webp";
import Soon from "../../Media/Leyora_Mobile.webp";

const soon = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281325283186&text=Halo%20Reza,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20(Leyora)%20https://perumahankotawisata.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div id="Orleans" className="Launching">
      <div className="louise">
        <h1>New Launching Kota Wisata Ecovia</h1>
        <h2>Cluster Leyora</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-lokasi-dekstop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
